import { WizNumberUtils } from '@wizeoo/akm-core-lib';
import { DATA_KIND } from '../../../model/enums';
import { FunctionObj } from '../../../vo/workingdata/function-obj';
import { MeasModeItem } from '../measure.mode.obj';
import { Model } from '../../../model/model';
/**
 * fonctions sur texte
 */
export class TextFunctions {


  public static functions(model: Model): FunctionObj[] {
      const funcArr: FunctionObj[] = [];

      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'FROMPERCENT', [DATA_KIND.STRING]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'CONCAT', [DATA_KIND.STRING], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'NBCHAR', [DATA_KIND.STRING])); // compte le nbr de charactères
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'TRIM', [DATA_KIND.STRING])); // trim
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'LEFT', [DATA_KIND.STRING, DATA_KIND.NUMBER])); // prend les x chars à gauche
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'RIGHT', [DATA_KIND.STRING, DATA_KIND.NUMBER])); // prend les x chars à droite
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'SUBSTR', [DATA_KIND.STRING, DATA_KIND.NUMBER, DATA_KIND.NUMBER])); // substring, start, len
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'REPLACE', [DATA_KIND.STRING, DATA_KIND.STRING, DATA_KIND.STRING])); // replace la chaine 1 par 2 dans 0
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'JOIN', [DATA_KIND.STRING], true)); // le premier, c'est le séparateur
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'REGEX', [DATA_KIND.MEASURE]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'UPPER', [DATA_KIND.STRING]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'LOWER', [DATA_KIND.STRING]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'PADLEFT', [DATA_KIND.STRING, DATA_KIND.STRING, DATA_KIND.NUMBER])); // ajoute x caractère au début d'une chaine pour correspondre à la taille requise
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_TEXT, 'PADRIGHT', [DATA_KIND.STRING, DATA_KIND.STRING, DATA_KIND.NUMBER])); // ajoute x caractère à la fin d'une chaine pour correspondre à la taille requise

      return funcArr;
  }

  /**
   * assemble les chaines de caractère
   *
   * @param mmi Etape de calcul concernée
   */
  public static CONCAT(mmi: MeasModeItem): void {
    let result: string = '';
    if (mmi.c && mmi.c.length > 0) {
      mmi.c.forEach((child: MeasModeItem) => {
        result += child.r || '';
      });
    }
    mmi.r = result;
    mmi.ftxt = true; // forcer le mode texte
  }

  /**
   * forcer la conversion d'un texte de type % en pourcentage
   * @param mmi Etape de calcul concernée
   */
  public static FROMPERCENT(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // valeurs

    const str = param1.r?.replace('%', '');
    let realNumber: number = null;
    if (!!str) {
      realNumber = WizNumberUtils.formatStringAsNumber(str);
    }

    mmi.r = realNumber?.toString();
  }


  /**
   * nbr de charactères d'une chaine de texte
   * @param mmi Etape de calcul concernée
   */
  public static NBCHAR(mmi: MeasModeItem): number {
    // console.log('NBCHAR FUNC', mmi);
    let result: number = 0;
    const valExist: string = mmi.c[0].r;
    if (!!valExist) {
      result = valExist.length;
    }
    mmi.r = result.toString();
    return result;
  }

  /**
   * trim
   * @param mmi Etape de calcul concernée
   */
  public static TRIM(mmi: MeasModeItem): string {
    // console.log('TRIM FUNC', mmi);
    let result: string = '';
    const valExist: string = mmi.c[0].r;
    if (!!valExist) {
      result = valExist.trim();
    }
    mmi.r = result;
    mmi.ftxt = true; // forcer le mode texte
    return result;
  }

  /**
   * REPLACE 1 par 2 dans 0
   * @param mmi Etape de calcul concernée
   */
  public static REPLACE(mmi: MeasModeItem): string {

    let result: string = '';
    const valExist: string = mmi.c[0].r;
    const from: string = mmi.c[1].r;
    const to: string = mmi.c[2].r;
    if (!!valExist) {

      const regexp: RegExp = new RegExp(from, 'g');
      const toStr: string =  to.replace(/\\(.)/g, '$1');
      // console.log('REPLACE FUNC', valExist, from, toStr);
      result = valExist.replace(regexp, toStr );
    }
    mmi.r = result;
    mmi.ftxt = true; // forcer le mode texte
    return result;
  }

  /**
   * Substring, from, len
   * @param mmi Etape de calcul concernée
   */
  public static SUBSTR(mmi: MeasModeItem): string {
    // console.log('SUBSTR FUNC', mmi);
    let result: string = '';
    const valExist: string = mmi.c[0].r;
    const from: number = Number(mmi.c[1].r);
    const len: number = Number(mmi.c[2].r);
    if (!!valExist) {
      result = valExist.substring(from, from + len);
    }
    mmi.r = result;
    mmi.ftxt = true; // forcer le mode texte
    return result;
  }

  /**
   * x à gauche
   * @param mmi Etape de calcul concernée
   */
  public static LEFT(mmi: MeasModeItem): string {
    // console.log('LEFT FUNC', mmi);
    let result: string = '';
    const valExist: string = mmi.c[0].r;
    const len: number = Number(mmi.c[1].r);
    if (!!valExist) {
      result = valExist.substring(0, len);
    }
    mmi.r = result;
    mmi.ftxt = true; // forcer le mode texte
    return result;
  }

  /**
   * x à droite
   * @param mmi Etape de calcul concernée
   */
  public static RIGHT(mmi: MeasModeItem): string {

    let result: string = '';
    const valExist: string = mmi.c[0].r;
    const len: number = Number(mmi.c[1].r);
    if (!!valExist) {
      const size: number = valExist.length;
      let start: number = size - len;
      if (start < 0) {
        start = 0;
      }
      result = valExist.substring(start, size);
    }
    mmi.r = result;
    mmi.ftxt = true; // forcer le mode texte
    // console.log('RIGHT FUNC',result, mmi);
    return result;
  }

  /**
   * assemble les chaines de caractère, avec séparateur
   *
   * @param mmi Etape de calcul concernée
   */
  public static JOIN(mmi: MeasModeItem): void {

    let separator: string = null;
    let first: boolean = true;
    const result: string[] = [];
    if (mmi.c && mmi.c.length > 0) {

      mmi.c.forEach((child: MeasModeItem) => {
        if (first) { // en première position, le séparateur
          separator = child.r ? child.r : '';
          first = false;
        } else if (!!child.r) {
          result.push(child.r);
        }
      });
    }
    if (result.length > 0) {
      mmi.r = result.join(separator);
      mmi.ftxt = true; // forcer le mode texte
    } else {
      mmi.r = '';
    }
    // mmi.flagText = true; // forcer le mode texte
  }

  /**
   * application REGEX au texte proposé: escape avec \
   * @param mmi Etape de calcul concernée
   */
  public static REGEX(mmi: MeasModeItem): string {
    let result: string = '';
    const valExist: string = mmi.c[0].r;
    if (!!valExist) {
      result =  valExist.replace(/\\(.)/g, '$1');
      // console.log('REPLACE FUNC', valExist, result);
    }
    mmi.r = result;
    mmi.ftxt = true; // forcer le mode texte
    return result;
  }

  /**
   * force en majuscule
   * @param mmi Etape de calcul concernée
   */
  public static UPPER(mmi: MeasModeItem): string {
    const param1: MeasModeItem = mmi.c[0]; // valeurs
    let result: string = '';
    const valExist: string = mmi.c[0].r;
    if (!!valExist) {
      result = valExist.toUpperCase();
    }
    mmi.r = result;
    return result;
  }

  /**
   * force en minuscule
   * @param mmi Etape de calcul concernée
   */
  public static LOWER(mmi: MeasModeItem): string {
    const param1: MeasModeItem = mmi.c[0]; // valeurs
    let result: string = '';
    const valExist: string = mmi.c[0].r;
    if (!!valExist) {
      result = valExist.toLowerCase();
    }
    mmi.r = result;
    return result;
  }

  /**
   * PAD ajoute x * caractère à une chaine, au début ou à la fin
   * @param mmi Etape de calcul concernée
   * @param start au début (true) ou à la fin
   * @returns la nouvelle chaine
   */
  public static PADBASIC(mmi: MeasModeItem, start: boolean = true): string {

    const existStr: string = mmi.c[0].r;
    const toAddChar: string = mmi.c[1].r;
    const targetSize: number = Number(mmi.c[2].r);

    let result: string = existStr;
    if (!!existStr && toAddChar.length === 1) {
      while(result.length < targetSize) {
        if(start) {
          result = toAddChar + result;
        } else {
          result = result + toAddChar;
        }
      }
    }

    return result;
  }

  /**
   * @param mmi Etape de calcul concernée
   */
  public static PADLEFT(mmi: MeasModeItem): string {
    mmi.r = this.PADBASIC(mmi, true);
    mmi.ftxt = true; // forcer le mode texte
    return  mmi.r;
  }

  /**
   * @param mmi Etape de calcul concernée
   */
  public static PADRIGHT(mmi: MeasModeItem): string {
    mmi.r = this.PADBASIC(mmi, false);
    mmi.ftxt = true; // forcer le mode texte
    return  mmi.r;
  }
}
